import React from "react";
import { Card, Icon, Empty, Tag, Spin, Progress } from "antd";
import { CompetitorContentAnalysisSection } from "../types";


const { Meta } = Card;
type Props = {
    summary: string | undefined;
    sections: CompetitorContentAnalysisSection[] | undefined;
    inProgress: boolean;
}
export function getColorByScore(seoScore: number) {
    if (seoScore < 50) return '#f63842';
    if (seoScore >= 50 && seoScore < 80) return '#ffab00';
    if (seoScore >= 80) return '#34bc6e';
}

export default function CompetitorContentAnalysis({ inProgress, summary, sections }: Props) {
    const sortedSectionsByCompetitorScore = sections ? [...sections].sort((a, b) => b.content_trust_score - a.content_trust_score) : [];

    return (
        <Card
            className="competitors-content-analysis"
            type="inner"
            title={
                <Meta
                    title={"Competitor Content Insights"}
                    description={"How your domain's content compares to competitors in the same niche"}
                />
            }
            extra={inProgress ? <Tag color="orange">Analysis in progress <Spin indicator={<Icon type="loading-3-quarters" spin style={{ fontSize: "12px", marginLeft: "6px" }} />} /></Tag> : null}
        >
            {inProgress && (<Empty description="" />)}
            {!inProgress && !summary && (sections && sections.length === 0) && (<Empty description="No competitors content analysis available" />)}
            {(!inProgress && summary) && (
                <>
                    <h4>Overview</h4>
                    <div className="competitors-summary" dangerouslySetInnerHTML={{ __html: summary }} />
                    <div className="competitors-analysis">
                        {sortedSectionsByCompetitorScore && sortedSectionsByCompetitorScore.map((section, index) => (
                            <div key={index} className="competitor-section">
                                <div className="competitor-header">
                                    <img
                                        className="favicon"
                                        src={`https://www.google.com/s2/favicons?domain=${section.competitor.domain}`}
                                        width="16"
                                        height="16"
                                        alt={`favicon of ${section.competitor.domain}`}
                                        onError={(e) => {
                                            e.currentTarget.className = 'default';
                                            if (e.currentTarget.src !== '/images/default_favicon.png') {
                                                e.currentTarget.src = '/images/default_favicon.png';
                                            }
                                        }}
                                    />
                                    <a href={section.competitor.url} rel="noopener noreferrer" target="_blank">
                                        {section.competitor.name}
                                    </a>
                                </div>

                                <div className="findings">
                                    <div className="strengths-and-weaknesses">
                                        <div className="findings-section">
                                            <ul className="finding strengths">
                                                {section.strengths && section.strengths.length > 0 && section.strengths.map((strength, idx) => (
                                                    <li key={idx}>
                                                        <Icon type="check-square" theme="filled" />
                                                        <span dangerouslySetInnerHTML={{ __html: strength }} />
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="findings-section">
                                            <ul className="finding weaknesses">
                                                {section.weaknesses && section.weaknesses.length > 0 && section.weaknesses.map((weakness, idx) => (
                                                    <li key={idx}>
                                                        <Icon type="warning" theme="filled" />
                                                        <span dangerouslySetInnerHTML={{ __html: weakness }} />
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="findings-section trust-score">
                                        <Progress
                                            type="circle"
                                            percent={section.content_trust_score}
                                            strokeWidth={6}
                                            width={72}
                                            strokeColor={getColorByScore(section.content_trust_score)}
                                            format={(percent) => `${percent}%`}
                                        />
                                        <h4 className="score-label">Content Trust Score</h4>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </Card>
    );
}